import gql from 'graphql-tag';

export const QUERY_LANDLORD_COMPANY_INFO = gql`
  query QueryLandlordCompany($userUuid: NonEmptyString!) {
    landlordContact(userUuid: $userUuid) {
      company {
        billingAddress
        billingCity {
          id
          name
        }
        billingCountry {
          id
          name
        }
        billingPostalCode
        businessNumber
        businessScale
        id
        name
        businessType
        businessScale
        companyType
        firstName
        lastName
        governmentIssuedId
      }
      id
    }
  }
`;

export const QUERY_LANDLORD_PERSONAL_INFO = gql`
  query QueryLandlordCompany($userUuid: NonEmptyString!) {
    landlordContact(userUuid: $userUuid) {
      enabled
      firstName
      id
      landlordId
      landlordLinkMen {
        contactEmail
        contactPhone
        id
      }
      lastName
    }
  }
`;

export const MUTATION_UPDATE_LANDLORD = gql`
  mutation mutationUpdateLandlordContact($input: UpdateLandlordContactInput!) {
    updateLandlordContact(input: $input) {
      landlordContact {
        email
        enabled
        firstName
        id
        lastName
        phone
      }
    }
  }
`;

export const MUTATION_UPDATE_LANDLORD_LINK_MAN = gql`
  mutation mutationUpdateLandlordLinkMan($input: UpdateLandlordLinkManInput!) {
    updateLandlordLinkMan(input: $input) {
      landlordLinkMan {
        contactEmail
        contactPhone
        id
      }
    }
  }
`;

export const MUTATION_CREATE_LANDLORD_LINK_MAN = gql`
  mutation mutationCreateLandlordLinkMan($input: CreateLandlordLinkManInput!) {
    createLandlordLinkMan(input: $input) {
      landlordLinkMan {
        contactEmail
        contactPhone
        id
      }
    }
  }
`;
